import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { UsersIcon, SearchIcon } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import { DataTable } from '../../components/ui/DataTable';
import { formatVND, formatPhone, getTierNameVi, formatDate } from '../../lib/formatters';
import { MOCK_CUSTOMERS } from '../../lib/mockData';
import type { Customer } from '../../lib/types';
export function CustomersPage() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const filtered = useMemo(() => {
    if (!search) return MOCK_CUSTOMERS;
    const q = search.toLowerCase();
    return MOCK_CUSTOMERS.filter(c => c.name.toLowerCase().includes(q) || c.phone.includes(q) || c.tier.includes(q));
  }, [search]);
  const columns = [{
    key: 'name',
    header: 'Khách hàng',
    render: (c: Customer) => <div data-id="element-734">
          <p className="font-medium text-white" data-id="element-735">{c.name || '—'}</p>
          <p className="text-xs text-[#666666]" data-id="element-736">{formatPhone(c.phone)}</p>
        </div>
  }, {
    key: 'tier',
    header: 'Hạng',
    render: (c: Customer) => <Badge variant="tier" tier={c.tier} size="sm" data-id="element-737">
          {getTierNameVi(c.tier)}
        </Badge>
  }, {
    key: 'points',
    header: 'Điểm',
    render: (c: Customer) => <span className="text-white" data-id="element-738">{c.points.toLocaleString('vi-VN')}</span>
  }, {
    key: 'wallet',
    header: 'Số dư ví',
    render: (c: Customer) => <span className="text-white font-medium" data-id="element-739">
          {formatVND(c.walletBalance)}
        </span>
  }, {
    key: 'spent',
    header: 'Tổng chi tiêu',
    render: (c: Customer) => <span className="text-[#B0B0B0]" data-id="element-740">{formatVND(c.totalSpent)}</span>,
    className: 'hidden md:table-cell'
  }, {
    key: 'lastPurchase',
    header: 'Mua gần nhất',
    render: (c: Customer) => <span className="text-[#666666] text-xs" data-id="element-741">
          {c.lastPurchaseAt ? formatDate(c.lastPurchaseAt) : '—'}
        </span>,
    className: 'hidden lg:table-cell'
  }, {
    key: 'tags',
    header: 'Tags',
    render: (c: Customer) => <div className="flex flex-wrap gap-1" data-id="element-742">
          {c.tags.slice(0, 2).map(tag => <Badge key={tag} size="sm" data-id="element-743">
              {tag}
            </Badge>)}
        </div>,
    className: 'hidden xl:table-cell'
  }];
  return <div data-id="element-744">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-745">
        <div className="flex items-center justify-between mb-6" data-id="element-746">
          <div data-id="element-747">
            <h1 className="text-2xl font-bold text-white flex items-center gap-3" data-id="element-748">
              <UsersIcon className="w-7 h-7 text-[#C8A84E]" data-id="element-749" />
              Khách Hàng
            </h1>
            <p className="text-sm text-[#666666]" data-id="element-750">
              {MOCK_CUSTOMERS.length} thành viên
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.05
    }} className="mb-4" data-id="element-751">
        <Input placeholder="Tìm theo tên, số điện thoại..." value={search} onChange={e => setSearch(e.target.value)} leftIcon={<SearchIcon className="w-4 h-4" data-id="element-753" />} data-id="element-752" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.1
    }} data-id="element-754">
        <Card padding="none" data-id="element-755">
          <DataTable columns={columns} data={filtered} keyExtractor={c => c.id} onRowClick={c => navigate(`/admin/khach-hang/${c.id}`)} emptyMessage="Không tìm thấy khách hàng" data-id="element-756" />
        </Card>
      </motion.div>
    </div>;
}